<div class="no-widgets" *ngIf="noWidgets">{{'WIDGETS.NOTIFICATION.NO_WIDGETS'|translate}}</div>
<div [ngStyle]="{
    'grid-template-columns': gridTemplateColumns,
    'grid-template-rows': gridTemplateRows
}"
class="grid-container mt-2 gap-2 pb-2 mh-110" #gridLayout
>
    <div (cdkDragEnded)="onDragEnd($event, widget)" [style.zIndex]="widget.zIndex"
         (cdkDragStarted)="onDragStarted($event)"
         *ngFor="let widget of widgets; let i = index; trackBy: trackById"
         [cdkDragFreeDragPosition]="{x: 0, y: 0}"
         [ngStyle]="widget.style"
         cdkDrag
         class="grid-item  mat-elevation-z3 rounded-4  {{editMode ? 'grid-item-edit' : ''}}"
    >
        <div class="card card_type_{{widgetsType[widget.widget_key]}} rounded-4 w-100 h-100">
            <div [cdkDragHandleDisabled]="widget.allowEditTitle"
                 cdkDragHandle
                 class="card-header d-flex justify-content-between"
            >
                <mat-form-field style="width: 70%;">
                    <input (keydown)="checkUpdates(widget)"
                           [(ngModel)]="widget.title" [cdkDragDisabled]="widget.allowEditTitle"
                           [readonly]="!widget.allowEditTitle"
                           class="title" matInput
                           [style.width]="widget.width*150+'px'"
                           [class.new_widget_title]="widget.new_widget"
                           [class.allow_edit_title]="widget.allowEditTitle"
                    >
                </mat-form-field>
                <span class="d-flex"
                      *ngIf="editMode"
                >
                    <i (click)="widget.allowEditTitle = !widget.allowEditTitle"
                       class="bi bi-pen me-2 active-icon"
                       [matTooltip]="'WIDGETS.EDIT_TITLE'|translate"
                    ></i>
                    <i (click)="openWidgetSettings(widget)"
                       class="bi bi-gear me-2 active-icon"
                       [matTooltip]="'WIDGETS.SETTINGS'|translate"
                    ></i>
                    <i (click)="deleteWidget(widget.id)"
                       class="bi bi-trash active-icon"
                       [matTooltip]="'WIDGETS.DELETE_WIDGET'|translate"
                    ></i>
                </span>
            </div>
            <div class="card-body2"
                 style="display: contents;"
            >
                <div [class.d-none]="editingWidget[i] && editingWidget[i].open"
                     class="mx-1 mb-1"
                     style="overflow: scroll; height: inherit;"
                >
                    <span *ngIf="!widget.options_dict && !widget?.content">Настрой виджет</span>
                    <ng-container *ngIf="widget?.content">
                        <ng-container
                                *ngComponentOutlet="widgetsComponents.get(widget.widget_key)?.component; inputs: {widgetData:widget};"
                        ></ng-container>
                    </ng-container>
                </div>
            </div>
            <div (mousedown)="onResizeMouseDown($event, widget)"
                 *ngIf="editMode"
                 class="resize-handle"
            >
                <i class="bi bi-textarea-resize"></i>
            </div>
        </div>
    </div>
</div>
<div class="fixed-button" *ngIf="isModifiedWidgets">
    <app-button-group-save-cancel
            (actionEvent)="widgetsUpdate($event)"
            [formState]="formState"
            data-action="widgetsUpdate"
    ></app-button-group-save-cancel>
</div>
